export default {
  containerClass: "container px-4 xl:px-2 mx-auto",
  containerFluidClass: "container-fluid xl:px-2 mx-auto",
};
